import { Middleware } from '@/app/router'
export default new Middleware('Cancel all request on route change', ({ _to, next }) => {
	return next()
})
